import moment from 'moment'

export const CurrentTimestamp = (): Date => {
    const now = moment()
    now.format('YYYY-MM-DDTHH:mm:ss.SSSZ')

    return now.toDate()
}

export const BaseTimeFormat = (date: Date): string => {
    const now = moment(date)
    return now.format('DD MMM YY, HH:mm')
}
